import { useEffect } from 'react'
import { Platform } from 'react-native'

const DEFAULT_WEB_DOCUMENT_TITLE = 'Impact Banking'

export function useWebDocumentTitle(title: string): void {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') {
      return
    }

    const previousTitle = document.title
    document.title = title

    return () => {
      document.title = previousTitle || DEFAULT_WEB_DOCUMENT_TITLE
    }
  }, [title])
}
